import styled from "@emotion/styled"
import { PHeading, PText } from "@porsche-design-system/components-react"
import { spacingStaticMd } from "@porsche-design-system/components-react/emotion"
import type { PricingView } from "@slfinrtl/ui-bff-routes"
import { Fragment } from "react"
import { defineMessages, FormattedMessage } from "react-intl"
import { emptyPlaceholder } from "src/common/emptyPlaceholder"
import { List, priceBreakdownMessages } from "src/components"

const messages = defineMessages({
	noExtraCostsHint: {
		defaultMessage: "No dealer fees were selected.",
		id: "vehicleDetails.overview.listing.extraCostsNotSelected",
	},
	placeholderCategory: {
		defaultMessage: "Dealer Add-Ons and Adjustments",
		id: "vehicleDetails.overview.listing.extraCostsPlaceholderCategory",
	},
	priceShownToCustomerHint: {
		defaultMessage: "This price is visible in front of the customer.",
		id: "vehicleDetails.overview.listing.extraCostsPriceShownToCustomerHint",
	},
	totalPrice: {
		defaultMessage: "Total price",
		id: "vehicleDetails.overview.listing.extraCostsTotalPrice",
	},
})

interface ExtraCostsPriceBreakdownProps {
	view: PricingView
}

export const ExtraCostsPriceBreakdown = (props: ExtraCostsPriceBreakdownProps) => {
	const {
		view: { customerPrice, priceBreakdown },
	} = props

	return (
		<StyledList>
			{priceBreakdown?.categories
				.filter((category) => category.showItemsToCustomer)
				.map((category, categoryIndex) => (
					<Fragment key={`category_${categoryIndex}`}>
						<List.Item label={<PHeading size="sm">{category.name}</PHeading>} />
						{category.items.map((item, itemIndex) => (
							<List.Item key={`item_${itemIndex}`} label={item.name} value={item.price} />
						))}
						<List.Item
							label={
								<PHeading size="sm">
									<FormattedMessage
										{...priceBreakdownMessages.categoryTotalPrice}
										values={{ categoryName: category.name }}
									/>
								</PHeading>
							}
							value={category.totalPrice}
						/>
					</Fragment>
				))}

			{!priceBreakdown && (
				<List.Item
					label={
						<>
							<PHeading size="sm">
								<FormattedMessage {...messages.placeholderCategory} />
							</PHeading>
							<PText color="contrast-medium">
								<FormattedMessage {...messages.noExtraCostsHint} />
							</PText>
						</>
					}
				/>
			)}

			<List.Item
				label={
					<>
						<PHeading size="sm">
							<FormattedMessage {...messages.totalPrice} />
						</PHeading>
						<PText color="contrast-medium">
							<FormattedMessage {...messages.priceShownToCustomerHint} />
						</PText>
					</>
				}
				value={
					<PText size="lg" weight="semibold">
						{priceBreakdown ? priceBreakdown.totalPrice : (customerPrice.value ?? emptyPlaceholder)}
					</PText>
				}
			/>
		</StyledList>
	)
}

const StyledList = styled(List)`
	li:last-of-type {
		border: 0;
		margin-top: ${spacingStaticMd};
	}
`
